import React, { Component } from 'react';
import { partnerApi } from './../../../../API/FetchCall';
const $ = require('jquery')
//$.DataTable = require('datatables.net')

class Invoice extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobilelist:[],
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data"))
    }
  }
  componentDidMount() {
    this.UserDataList();
  }
  UserDataList = async () => {
    try {
      let req = JSON.stringify({
        role: 3,
        partner_id: this.state.auth_data.login_id,
        url: 'getTransaction'
      });
      const res = await partnerApi(req);
      if (res.status == 1) {
        console.log("invoice",res.list);
        this.setState({mobilelist:res.list});
        //this.datatabledata(res.list);
      } else {
        //this.datatabledata([]);
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };
  datatabledata(data) {

    console.log('data', data)
    this.setState({
      dataSet: data
    })
    this.el = $(this.el)
    this.el.DataTable(
      {
        data: this.state.dataSet,
        columns: [
          { data: 's_no' },
          { data: 'created_date' },
          { data: 'description'},
          { data: 'razorpay_payment_id' },
          { data: 'invoice_no' },
          { data: 'amount' },
          { data:'status'},
          { data: 'action' },
        ]

      }
    )
  }
  render() {
    return (
      <React.Fragment>
        <div className="box-shadow-custom desktoponly" >
          <div className="table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no">
            <table className="table table-custom-design table-striped">
              <thead>
                <tr>
                  <th className="tabledata">S.No</th>
                  <th className="tabledata">Date</th>
                  <th className="tabledata w100px" width="100px">Desc</th>
                  <th className="tabledata">RazorPay Id</th>
                  <th className="tabledata w100px" width="100px">Invoice</th>
                  <th className="tabledata">Amount</th>
                  <th className="tabledata">Status</th>
                  <th className="tabledata w50px">Action</th>
                </tr>
              </thead>
              <tbody>
              {this.state.mobilelist.map((invitem, index) => (
                  <tr class="">
                    <td>{index+1}</td>
                    <td>{invitem.created_date}</td>
                    <td>{invitem.description}</td>
                    <td>{invitem.razorpay_payment_id}</td>
                    <td>{invitem.invoice_no}</td>
                    <td>{invitem.amount}</td>
                    <td>{invitem.status}</td>
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html: invitem.action}}></td>
                  </tr>  
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="mobileonly" >

              <div class="invoiceline">
                {this.state.mobilelist.map((invitem, index) => (
                  <div class="mobileinvline box-shadow-custom">
                    <h2>{invitem.invoice_no}</h2>
                    <div><b>Date :</b> <br/> {invitem.created_date}</div>
                    <div><b>Desc :</b> <br/> {invitem.description}</div>
                    <div><b>Razor Pay ID :</b> <br/>{invitem.razorpay_payment_id}</div>
                    <div><b>Amount:</b> <br/>{invitem.amount}</div>
                    <div><b>Status :</b> <br/> {invitem.status}</div>
                    <div style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html: invitem.action}}></div>
                  </div>  
                ))}
              </div>

        </div>
      </React.Fragment>
    );

  }
}

export default Invoice;





// WEBPACK FOOTER //
// ./src/components/bewise/partners/subscribe/invoice.jsx